import jp from './lang_JP'
import en from './lang_EN'

// jsonを結合する
const i18nData = Object.assign(en, jp)

export default i18nData



// WEBPACK FOOTER //
// ./src/lib/lang/index.js